import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProfileNewPage } from './profile-new';

@NgModule({
  declarations: [
    ProfileNewPage,
  ],
  imports: [
    IonicPageModule.forChild(ProfileNewPage),
  ],
})
export class ProfileNewPageModule {}



// WEBPACK FOOTER //
// ./src/pages/profile-new/profile-new.module.ts